// extracted by mini-css-extract-plugin
export var container = "ImageSection-module--container--FoinP";
export var image = "ImageSection-module--image--1W06c";